import React, { useEffect, useState } from "react";
import { DKGridTable } from "../../../common/grid/DKGridTable";
import * as api from "../../../../api/generated-api";
import { Box, Typography } from "@mui/material";
import { DKGridColumn } from "../../../common/grid/DKGridColumn";
import DKFormTextInput from "../../../common/widgets/formVariablesWidget/DKFormTextInput";
import Button from "../../../common/forms/button";
import { DealPageActionButtonInfo } from "../../dealsPageLayout/DealsPageHeader/DealsPageHeader";
import { toValidIdentifier } from "../../../../helpers/utilsTS";
import InvestorRowCellWrapper from "../InvestorRowCellWrapper";
import InvestorActionCellWrapper from "../InvestorActionCellWrapper";

type LegalEntitiesGridProps = {
  items: api.DealLegalEntity[];
  editRowIndex: number;
  canEditInvestorInfo: boolean;
  onEdit: (index: number) => void;
  onCancel: () => void;
  onSave: (item: api.DealLegalEntity) => void;
  onAdd: () => void;
};
export const LegalEntitiesGrid = (props: LegalEntitiesGridProps) => {
  const {
    items,
    editRowIndex,
    canEditInvestorInfo,
    onEdit,
    onCancel,
    onSave,
    onAdd,
  } = props;
  const [rows, setRows] = useState<api.DealLegalEntity[]>(items);

  useEffect(() => {
    setRows(items);
  }, [items]);

  const updateRowValue = (index: number, value: api.DealLegalEntity) => {
    const newRows = [...rows];
    newRows[index] = value;
    setRows(newRows);
  };

  const actionButtons: DealPageActionButtonInfo[] = [];

  if (editRowIndex != undefined) {
    actionButtons.push({
      dataTestId: "cancel-legal-entities",
      label: "cancel",
      onClick: () => {
        onCancel();
      },
    });
    actionButtons.push({
      dataTestId: "save-legal-entities",
      label: "save",
      onClick: () => {
        onSave(rows[editRowIndex]);
      },
    });
  } else if (canEditInvestorInfo) {
    actionButtons.push({
      dataTestId: "add-legal-entity",
      label: "add",
      onClick: () => {
        onAdd();
      },
    });
  }

  return (
    <>
      <DKGridTable
        title={"Legal Entities"}
        rowsLength={rows.length}
        actionButtons={actionButtons}
      >
        <DKGridColumn width={6} title={"Investing Entity Legal Name"}>
          {rows.map((item, itemIndex) => {
            if (editRowIndex != itemIndex) {
              return (
                <InvestorRowCellWrapper key={"name-" + itemIndex}>
                  <Typography
                    data-testid={"legal-entity-name"}
                    variant={"body1"}
                  >
                    {item.name}
                  </Typography>
                </InvestorRowCellWrapper>
              );
            } else {
              return (
                <DKFormTextInput
                  key={"legal-entity-name-field-" + itemIndex}
                  dataTestId={"legal-entity-name-field"}
                  name={"name"}
                  label={""}
                  value={item.name}
                  onChange={(event) => {
                    updateRowValue(itemIndex, {
                      ...rows[itemIndex],
                      name: event.target.value,
                    });
                  }}
                />
              );
            }
          })}
        </DKGridColumn>
        <DKGridColumn width={6}>
          {rows.map((item, itemIndex) => {
            if (editRowIndex != itemIndex) {
              return (
                <InvestorRowCellWrapper key={"row-actions-" + itemIndex}>
                  <InvestorActionCellWrapper>
                    <Box
                      display={"flex"}
                      justifyContent={"flex-end"}
                      alignItems={"center"}
                    >
                      <Button
                        data-testid={toValidIdentifier(
                          "legal-entity-edit-" + item.name
                        )}
                        type="ghost"
                        size="small"
                        onClick={() => {
                          onEdit(itemIndex);
                        }}
                      >
                        edit
                      </Button>
                    </Box>
                  </InvestorActionCellWrapper>
                </InvestorRowCellWrapper>
              );
            } else {
              return (
                <InvestorRowCellWrapper
                  key={"row-actions-" + itemIndex}
                  editMode
                ></InvestorRowCellWrapper>
              );
            }
          })}
        </DKGridColumn>
      </DKGridTable>
    </>
  );
};
